import type { Stage } from '@api/types'
import type { MyStages } from '@lib/my-stages'

export type StageProgress = { done: number; total: number; doneKm: number; totalKm: number }

// Avance del caminante sobre las etapas publicadas. Las etapas marcadas que ya no se publican
// (retiradas en una importación) no cuentan.
export const stageProgress = (stages: Pick<Stage, 'id' | 'distanceKm'>[], mine: MyStages): StageProgress => {
	const done = stages.filter((stage) => stage.id in mine)
	const sum = (list: typeof stages) => list.reduce((km, stage) => km + stage.distanceKm, 0)
	return { done: done.length, total: stages.length, doneKm: sum(done), totalKm: sum(stages) }
}
